// import React from 'react'

export const AssistantPage = () => {
    return (
        <div className="">
            <h2>Assistant Page</h2>
            <p>This is the assistants page</p>
        </div>
    )
}

export default AssistantPage